<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-03",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 55,
      nextPage: '/questionnaire/section4/4',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'Do gums bleed often?',
        btn: [
          [
            {
              text: 'Yes',
              operation: 'add suggestion 13'
            },{
              text: 'No',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
